// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  width: 100vw;
  height: 99vh;
  background-color: white;
}

body{
  margin:0;
  padding: 0;
  overflow: hidden;
}

.item {
  list-style-type: none;
  padding: 10px;
  margin: 5px 0;
  background-color: #f4f4f4;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: grab;
  transition: background-color 0.3s ease;
}

.item:hover {
  background-color: #e0e0e0;
}

.item.dragging {
  background-color: #d0d0d0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  cursor: grabbing;
}


.accordion-item {
  border: 1px solid #ccc;
  margin-bottom: 10px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.accordion-item.dragging {
  opacity: 0.5;
  transform: scale(1.05);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.accordion-header {
  display: flex;
  align-items: center;
  background-color: #f0f0f0;
  padding: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.drag-handle {
  margin-right: 10px;
  cursor: move;
}

.title {
  flex-grow: 1;
}

.arrow {
  width: 20px;
  height: 20px;
}

.animate-flip {
  transition: transform 0.3s ease;
}

.animate-flip.open {
  transform: rotate(180deg);
}

.accordion-content {
  padding: 10px;
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;AAClB;;;AAGA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".App {\n  width: 100vw;\n  height: 99vh;\n  background-color: white;\n}\n\nbody{\n  margin:0;\n  padding: 0;\n  overflow: hidden;\n}\n\n.item {\n  list-style-type: none;\n  padding: 10px;\n  margin: 5px 0;\n  background-color: #f4f4f4;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  cursor: grab;\n  transition: background-color 0.3s ease;\n}\n\n.item:hover {\n  background-color: #e0e0e0;\n}\n\n.item.dragging {\n  background-color: #d0d0d0;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  cursor: grabbing;\n}\n\n\n.accordion-item {\n  border: 1px solid #ccc;\n  margin-bottom: 10px;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n}\n\n.accordion-item.dragging {\n  opacity: 0.5;\n  transform: scale(1.05);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n}\n\n.accordion-header {\n  display: flex;\n  align-items: center;\n  background-color: #f0f0f0;\n  padding: 10px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.drag-handle {\n  margin-right: 10px;\n  cursor: move;\n}\n\n.title {\n  flex-grow: 1;\n}\n\n.arrow {\n  width: 20px;\n  height: 20px;\n}\n\n.animate-flip {\n  transition: transform 0.3s ease;\n}\n\n.animate-flip.open {\n  transform: rotate(180deg);\n}\n\n.accordion-content {\n  padding: 10px;\n  background-color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
